import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { Pagination } from 'interfaces/api.interfaces'
import { Template } from 'interfaces/api/templates.interfaces'
import {
  CreateTemplateParams,
  RemoveTemplateParams,
  UpdateTemplateFieldsParams,
  UpdateTemplateParams,
} from 'interfaces/store/templates.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'
import { toServerTemplatedData } from 'utils/templatesMapper'

export const getAllTemplates = createAsyncThunk(
  'templates/getAllTemplates',
  async (params: Pagination, { rejectWithValue }) =>
    api.templates.getAll(params).catch((error) => rejectWithValue(error.message)),
)

export const getTemplate = createAsyncThunk('templates/getTemplate', async (id: number, { rejectWithValue }) =>
  api.templates.getSingle(id).catch((error) => rejectWithValue(error.message)),
)

export const setSingleTemplate = createAction<null | Template>('templates/setSingleTemplate')

export const getProjectHierarchies = createAsyncThunk(
  'templates/getProjectHierarchies',
  async (projectId: number, { rejectWithValue }) =>
    api.templates.getProjectHierarchies(projectId).catch((error) => rejectWithValue(error.message)),
)

export const getTemplateDestroyPreview = createAsyncThunk(
  'templates/getTemplateDestroyPreview',
  async (id: number, { rejectWithValue }) =>
    api.templates.getDestroyPreview(id).catch((error) => rejectWithValue(error.message)),
)
export const setTemplateValidationErrors = createAction<ValidationErrorsApi | null>(
  'templates/setTemplateValidationErrors',
)

export const createTemplate = createAsyncThunk(
  'templates/createTemplate',
  async (params: CreateTemplateParams, { rejectWithValue, dispatch }) =>
    api.templates
      .create(toServerTemplatedData(params.data))
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setTemplateValidationErrors(null))
        toast.success(Success.TemplateCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setTemplateValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateTemplate = createAsyncThunk(
  'templates/updateTemplate',
  async (params: UpdateTemplateParams, { rejectWithValue, dispatch }) =>
    api.templates
      .update(params.id, toServerTemplatedData(params.data))
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setTemplateValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setTemplateValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeTemplate = createAsyncThunk(
  'templates/removeTemplate',
  async (params: RemoveTemplateParams, { rejectWithValue }) =>
    api.templates
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.TemplateRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const updateTemplateFields = createAsyncThunk(
  'templates/updateTemplateFields',
  async (params: UpdateTemplateFieldsParams, { rejectWithValue }) =>
    api.templates.updateTemplateFields(params.templateId, params.data).catch((error) => rejectWithValue(error.message)),
)
